import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { orderOrderActions } from "../../../../store/external/order/order.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TABLE_PAGINATION_KEY, DASHBOARD_LABEL, MODAL_CUSTOM_MESSAGE, REQUEST_TYPES_ID } from "../../../../constants/external-constants";
import '../../../external/invoice/invoice/invoice.css';
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import OrderDetails from "./order-details/order-details.component";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import RequestDetailDisplay from "../../../external/request/request-details/request-details-modal-display.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ROUTE_LINK_LOCATION } from "../../../../constants/external-constants";
import { filterActions } from "../../../../store/external/filter-reducer/filter-reducer";

class Order extends Component {
    constructor(props) {
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.state = {
            viewDetailPage: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            displaySearch: false,
            headerTitle: "order_management",
            statusActiveFilter: 0,
            orderDetailsId: 0,
            orderNumber: 0,
            quotationRequestId: 0,
            requestTypeId: 0,
            stripeInfo: null,
            item: {}
        }

    }

    componentDidMount() {
        this.changeHeaderTitle();
        this.props.applyAllOrderStatusFilter(0);
        this.props.getAllOrder();
    }

    componentWillUnmount() {
        this.props.setDefaultAllOrder();
        this.props.resetFilter();
    }

    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    handleCreateNewAction = () => {
        this.setState({
            showModal: true,
        })
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                createNew: !this.state.createNew,
                showModal: false
            }, this.changeHeaderTitle);
        } else {
            this.setState({ showModal: false })
        }

    }
    resizePage = (value) => {
        const { getAllOrder, resizeAllOrderPage } = this.props;
        resizeAllOrderPage(value);
        getAllOrder();
    }

    changeHeaderTitle() {
        if (this.state.viewDetailPage || this.state.createNew) {
            this.setState({ headerTitle: "order_details_view" })
        } else {
            this.setState({ headerTitle: "order_management" })
        }
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractAllOrder();
        }
    };

    applyFilter = (isApply) => {
        const { getAllOrder, applyAllOrderFilter } = this.props;
        applyAllOrderFilter(isApply);
        getAllOrder(0);
    }

    handleCloseDetailsPage = () => {
        this.setState({
            viewDetailPage: false,
            headerTitle: "order_management",
            orderDetailsId: 0,
            quotationRequestId: 0,
            orderNumber: 0
        });
        this.props.getAllOrder();
    }

    setHeaderTitle(item) {
        return item.RequestTypeId === REQUEST_TYPES_ID.newQuotation ? "quotation_details_view" : "order_details_view";
    }

    async viewDetails (isNew, item) {
        if (!isNew) {
            var res = await this.props.hasStripeCustomerId(item.OrderId)
            this.setState({
                headerTitle: this.setHeaderTitle(item),
                viewDetailPage: true,
                orderDetailsId: item.OrderId,
                orderNumber: item.OrderNum,
                quotationRequestId: item.OrderId,
                requestTypeId: item.RequestTypeId,
                stripeInfo: res,
                item: item
            });
        }
    }

    statusActiveFilter = (statusActiveFilter) => {
        const { getAllOrder, applyAllOrderStatusFilter } = this.props;
        applyAllOrderStatusFilter(statusActiveFilter)
        getAllOrder(0);
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }
    closeDetailsView = () =>{
        const { getAllOrder, setLoadForm } = this.props;
        this.setState({viewDetailPage : false},()=>{
            this.changeHeaderTitle();
        });
        setLoadForm(false)
        getAllOrder(0);
    }
    render() {
        const { orderOrder, getAllOrder, sortAllOrderItems, setAllOrderColSearchStr, addAllOrderFilter, removeAllOrderFilter, saveAllOrderCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.orderOrder.allOrderItems.Columns;
        const { FirstFilter, SecondFilter, ThirdFilter, FourthFilter, TotalFilter } = this.props?.orderOrder?.allOrderItems.StatusFilter || {};
        const { orderDetailsRouteLink, orderId, qoutationId } = ROUTE_LINK_LOCATION;
        const statusData = [
            { "label": DASHBOARD_LABEL.total, "value": TotalFilter ?? 0 },
            { "label": DASHBOARD_LABEL.open, "value": FirstFilter ?? 0 },
            { "label": DASHBOARD_LABEL.inProgress, "value": SecondFilter ?? 0 },
            { "label": DASHBOARD_LABEL.completed, "value": ThirdFilter ?? 0 },
            { "label": DASHBOARD_LABEL.cancelled, "value": FourthFilter ?? 0 }
        ];
        var fetchId = REQUEST_TYPES_ID.newQuotation ? qoutationId : orderId
   
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.OrderOrderDashboardRW])
       
        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={this.state.headerTitle} />
                <div className="request-table data-table fit-width">
                    {
                            <>
                            {
                                this.state.viewDetailPage? (
                                    <BrowserRouter>
                                        <Switch>
                                            <OrderDetails closeForm={this.closeDetailsView} stripeInfo={this.state.stripeInfo} quotationRequestId={this.state.quotationRequestId} orderDetailsId={this.state.orderDetailsId} item={this.state.item}>                                       
                                                <Route exact path={`${orderDetailsRouteLink}${fetchId}`} requestTypeId={this.state.RequestTypeId}  component={RequestDetailDisplay} />
                                            </OrderDetails> 
                                        </Switch>
                                    </BrowserRouter>
                               
                                ) : 
                                (
                                    <DetailsDashboard
                                // Filter Properties
                                data={orderOrder.allOrderItems.TableFilterData}
                                translation={""}
                                addAction={addAllOrderFilter}
                                removeAction={removeAllOrderFilter}
                                applyAction={this.applyFilter}

                                //CreateNew Action
                                            createNewAction={this.handleCreateNewAction}
                                            isCreateButtonHidden={true}

                                //View Search Textbox
                                viewSearchAction={this.DisplaySearhBox}

                                //Customize Column
                                firstList={Available}
                                secondList={Selected}
                                defaultList={Default}
                                saveAction={saveAllOrderCustomCols}

                                //Extract Button
                                extractAction={(e) => this.onClickExtract(e)}

                                //StatusBar
                                statusData={statusData}
                                activeStatusFilter={this.statusActiveFilter}

                                //Access Type
                                 isReadOnly={isReadOnly}
                                 isReadAndExtractOnly={isReadAndExtractOnly}
                                 isReadAndWrite={isReadAndWrite}

                                >
                                    {this.props.orderOrder.isAllOrderLoaded ?
                                        <TablePagination
                                            key={TABLE_PAGINATION_KEY.orderOrder}
                                            classNameWrapper="overflow-auto"
                                            columns={orderOrder.allOrderItems.Headers}
                                            pageList={orderOrder.allOrderItems.Data}
                                            pages={orderOrder.allOrderItems.Pagination}
                                            rowClickAction={(item) => { this.viewDetails(false, item) }}
                                            paginationAction={getAllOrder}
                                            onColumnClick={sortAllOrderItems}
                                            onColumnSearch={() => { getAllOrder(0) }}
                                            onColumnSearchChange={setAllOrderColSearchStr}
                                            isColSearchShow={this.state.displaySearch}
                                            resizePage={this.resizePage}
                                            totalPage={orderOrder.allOrderItems.Pagination.TotalEntries}
                                            tablePaginationKey={TABLE_PAGINATION_KEY.orderOrder}
                                        />
                                        : this.loading()}
                                </DetailsDashboard>
                                )
                            }
                            
                            </>
                    }

                </div>
            </div>
        )
    }
}
export default withRouter(connect(
    state => {
        const { orderOrder } = state;

        return {
            orderOrder
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, orderOrderActions, filterActions),
        dispatch
    )
)(Order));